module.exports = __webpack_public_path__ + "assets/images/7ea5f2d15373dd2d2a90396406111eb7.png";